import {
  HeartPulse,
  Stethoscope,
  Sofa,
  Baby,
  Gift,
  Sparkles,
  Shirt,
  Cpu,
  Wrench,
  PartyPopper,
  Package,
  Bike,
} from "lucide-react";

const INDUSTRIES = [
  {
    icon: HeartPulse,
    title: "Medical & Healthcare",
    blurb: "Rapid test kits, diagnostic devices, hospital beds, PPE, sanitizers — clinical & institutional grade.",
    client: "Dispomate, Prevalent",
  },
  {
    icon: Stethoscope,
    title: "Dental & Orthodontic",
    blurb: "Surgical materials, orthodontic brackets, disposables, impression trays, sterilization equipment.",
    client: "Orthodent",
  },
  {
    icon: Baby,
    title: "Toys & Baby Products",
    blurb: "Educational toys, plush, play sets, strollers, feeding accessories, safety-certified nursery items.",
    client: "Baybee, Kidzon",
  },
  {
    icon: Sofa,
    title: "Furnishings & Interiors",
    blurb: "Home & office furniture, decor, curtains, rugs, lighting, wall art, cushions and accessories.",
    client: "Style Union",
  },
  {
    icon: Gift,
    title: "Gifts & Souvenirs",
    blurb: "Promotional merchandise, corporate gifts, novelty items, branded giveaways, souvenir collections.",
    client: "Historical Wales",
  },
  {
    icon: Sparkles,
    title: "Beauty & Personal Care",
    blurb: "Skincare, cosmetics, hair care, hygiene, wellness, salon equipment and beauty accessories.",
  },
  {
    icon: Shirt,
    title: "Textiles & Fashion",
    blurb: "Apparel, leather goods, bags, luggage, fashion accessories, scarves and premium textiles.",
  },
  {
    icon: Cpu,
    title: "Electronics & Electrical",
    blurb: "Consumer electronics, smart home, electrical components, LED lighting, power tools, audio.",
  },
  {
    icon: Wrench,
    title: "Hardware & Tools",
    blurb: "Hand tools, power tools, fasteners, construction materials, industrial-grade equipment.",
  },
  {
    icon: PartyPopper,
    title: "Seasonal & Holiday",
    blurb: "Christmas, Eid, festivals, party supplies, New Year, Halloween — sourced and shipped on time.",
  },
  {
    icon: Package,
    title: "Packaging & Stationery",
    blurb: "Custom packaging, gift boxes, paper products, office supplies, eco-friendly materials.",
  },
  {
    icon: Bike,
    title: "Transport & Recreation",
    blurb: "Bicycles, motorbikes, e-scooters, outdoor sports goods, camping equipment and spare parts.",
  },
];

export default function Industries() {
  return (
    <section
      id="industries"
      data-testid="industries-section"
      className="relative bg-white py-14 md:py-28"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 items-end mb-14 md:mb-16">
          <div className="md:col-span-7">
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-signal mb-5">
              02 — Industries we move
            </p>
            <h2 className="font-heading font-black text-ink-900 tracking-[-0.03em] leading-[0.95] text-4xl md:text-5xl lg:text-6xl">
              Twelve verticals.<br />
              <span className="text-stroke">One operator.</span>
            </h2>
          </div>
          <p className="md:col-span-5 text-ink-500 text-base md:text-lg leading-relaxed">
            From medical disposables to plush toys, dental brackets to LED
            lighting — we source, audit, pack, ship and clear across every
            major consumer and industrial category.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {INDUSTRIES.map((v) => {
            const Icon = v.icon;
            return (
              <article
                key={v.title}
                data-testid={`industry-${v.title.replace(/\s+/g, "-").toLowerCase()}`}
                className="group p-6 md:p-7 bg-ink-50 border border-ink-100 hover:border-signal hover:-translate-y-1 transition-all duration-300"
              >
                <div className="flex items-start justify-between">
                  <div className="w-11 h-11 flex items-center justify-center border border-ink-100 text-ink-900 group-hover:border-signal group-hover:text-signal transition-colors">
                    <Icon className="w-5 h-5" strokeWidth={1.6} />
                  </div>
                  {v.client && (
                    <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-ink-500">
                      {v.client}
                    </span>
                  )}
                </div>
                <h3 className="mt-5 font-heading font-bold text-lg md:text-xl tracking-tight text-ink-900">
                  {v.title}
                </h3>
                <p className="mt-2 text-ink-500 text-sm leading-relaxed">{v.blurb}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
